module.exports = __webpack_public_path__ + "img/c3-2.1136c11f.jpg";